import { useParams, useLocation } from 'react-router-dom';
import { 
  removeInternalUserRoleEndpoint, 
  getInternalUserAssignedRolesEndpoint, 
  updateInternalUserRolesEndpoint 
} from '../internal-users/services/rolesService';

import RolesManagement, { RolesService } from '../../components/RolesManagement'; 

const InternalUserRolesManagement = () => {
  const { userId = '' } = useParams();
  const location = useLocation();
  const userEmail = location.state?.userEmail || ''; 

  const internalUserServices: RolesService = {
    getUserRoles: (uId, token) => getInternalUserAssignedRolesEndpoint(token, uId),
    assignRole: (uId, roleId, token) => updateInternalUserRolesEndpoint(token, uId, roleId),
    removeRole: (uId, roleId, token) => removeInternalUserRoleEndpoint(token, uId, roleId),
  };

  return (
    <RolesManagement
      userId={userId}
      userEmail={userEmail}
      service={internalUserServices}
      pageName="Administración de Roles"
      pageParentName="Usuarios Internos"
    />
  );
};

export default InternalUserRolesManagement;